<ion-app>
  <!-- Only accept swipe gestures within tab pages, not on global level.
   Without this deactivated, the user can swipe back to login page. -->
  <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>
</ion-app>
